module.exports = ".btn-slide.btn-slide-print {\n    background: #47b8e0;\n    color: #fff;\n  }\n\n  .btn-slide.btn-slide-print:before {\n    background: #fff;\n    border: 2px solid #47b8e0;\n    color: #47b8e0;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscription/subscription-view-passenger/subscription-view-passenger.component.css
// module id = ./src/app/components/subscription/subscription-view-passenger/subscription-view-passenger.component.css
// module chunks = main